import { Component, OnInit, ViewEncapsulation, Input, SimpleChanges } from '@angular/core';
import { Router } from "@angular/router";

import { AuthService } from "../../services/auth.service";

@Component({
  selector: 'app-reverify',
  templateUrl: './reverify.component.html',
  styleUrls: ['../../app.component.scss', './reverify.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReverifyComponent implements OnInit {
  
  resendMailData = <any>{};
  
  constructor(private _auth: AuthService, private _router: Router) {
  }

  ngOnInit() {
  }

  resetForm() {
    this.resendMailData.email = "";
  }

  reverify() {
    this._auth.resendEmail(this.resendMailData)
      .subscribe(
        res => {
        },
        error => {
          if (error.status == 0) {
          } else {
          }
        }
      )
  }
}